module.exports = __webpack_public_path__ + "static/media/GothamLight.a31257a9.woff";